import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=5f8ee845&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=5f8ee845&scoped=true&lang=css&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=5f8ee845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ee845",
  null
  
)

component.options.__file = "Welcome.vue"
export default component.exports